// src/components/billing/EndCustomerRollupPreview.tsx
import { Group, Text } from "@mantine/core";
import { formatMoney } from "../../utils/format";

interface Props {
  customerCount: number;
  perCustomerAmount: number;
  currency?: string;
  frequency?: "MONTHLY" | "QUARTERLY" | "ANNUAL";
}

const FREQ_LABEL: Record<string, string> = {
  MONTHLY: "сар",
  QUARTERLY: "улирал",
  ANNUAL: "жил",
};

export function EndCustomerRollupPreview({
  customerCount,
  perCustomerAmount,
  currency = "MNT",
  frequency = "MONTHLY",
}: Props) {
  const total = customerCount * perCustomerAmount;
  return (
    <Group gap="xs" style={{ fontVariantNumeric: "tabular-nums" }}>
      <Text size="sm">{customerCount} харилцагч</Text>
      <Text size="sm" c="dimmed">×</Text>
      <Text size="sm">{formatMoney(perCustomerAmount, currency)}</Text>
      <Text size="sm" c="dimmed">=</Text>
      <Text size="sm" fw={700} c="brand.7">{formatMoney(total, currency)} / {FREQ_LABEL[frequency] ?? "сар"}</Text>
    </Group>
  );
}
